module.exports = __webpack_public_path__ + "img/Moves.c505e1bd.png";